module.exports = __webpack_public_path__ + "img/white_logo.94706841.png";